import * as React from 'react'
import styled from 'styled-components'
import { fontSize } from '~/assets/styleConstants'
import { SlideInBurgerMenu } from './SlideInBurgerMenu'
import { TwoAreasTopNavBar } from './TwoAreasTopNavBar'

const ElementWrapper = styled.div`
    margin-left: 24px;
    display: inline-flex;
    align-self: center;
`
const PageTitle = styled(ElementWrapper)`
    font-size: ${fontSize.medium_16};
`

type TopNavBarMobileProps = {
    rightElements?: React.ReactNode[]
    pageTitle?: string
}

export function TopNavBarMobile({
    rightElements,
    pageTitle,
}: TopNavBarMobileProps) {
    let pageSpecificElements = null
    if (rightElements) {
        pageSpecificElements = rightElements.map((el, i) => (
            <ElementWrapper key={`TopNavBarRightElement${i}`}>
                {el}
            </ElementWrapper>
        ))
    }
    const leftElements = [
        <SlideInBurgerMenu key={'menu_mobile'} />,
        <PageTitle key={'title'}>{pageTitle}</PageTitle>,
    ]

    return (
        <TwoAreasTopNavBar
            left={leftElements}
            right={pageSpecificElements}
            hideUserAvi={true}
        />
    )
}
